import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';

import { NestBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { AssetDescription } from '@play-co/timestep-core';

// constants
//-----------------------------------------------------------------------------
const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/nest'),
    loadMethod: MovieClip.animationLoader,
  },
});

/*
    nest block view
*/
export class NestBlockView extends Container {
  private _animation: MovieClip;

  // init
  //-------------------------------------------------------------------------
  constructor(props: NestBlockProps) {
    // create base view
    super();
    this._animation = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
      fps: 20,
    });
    blockPositionView(this, props);

    this.y += 1;
    this._playIdle();
  }

  public async playSpawnFx() {
    await this._animation.playAsync('bee_spawn');
    this._playIdle();
  }

  private _playIdle() {
    this._animation.play('bee_hive', null, true);
  }

  public static assets(): (string | AssetDescription<unknown>)[] {
    return Object.values(manifest());
  }
}
